import {
  clearVote,
  create,
  get,
  list,
  listReplies,
  pin,
  remove,
  setVote,
  unpin,
  update,
} from "./endpoints";

export { noSuchComment, notPublished, service } from "./endpoints";
export {
  Comment,
  CommentAuthor,
  CommentBody,
  CommentId,
  CommentIdParams,
  CommentMention,
  CommentModeration,
  CommentSort,
  CommentStatus,
  CommentSubject,
  CommentViewer,
  CommentVoteCount,
  CommentVoteValue,
  CreateCommentRequest,
  CreateCommentResponse,
  GetCommentResponse,
  ListCommentsQuery,
  ListCommentsResponse,
  ListRepliesQuery,
  ListRepliesResponse,
  MAX_PINS_PER_SUBJECT,
  ReplyComment,
  ReplySiblings,
  SetCommentVoteRequest,
  TopLevelComment,
  UpdateCommentRequest,
  UpdateCommentResponse,
} from "./schemas";

export const contract = {
  list,
  create,
  get,
  update,
  delete: remove,
  replies: { list: listReplies },
  vote: { set: setVote, delete: clearVote },
  pin: { set: pin, delete: unpin },
} as const;
